const start = "{{",
  end = "}}",
  path = "[a-z0-9_$][\\.a-z0-9_]*",
  pattern = new RegExp(start + "\\s*(" + path + ")\\s*" + end, "gi");

export default function stringTemplate(
  template: string,
  data: Record<string, any> = {}
): string {
  return template.replace(pattern, function (tag, token) {
    const path = token.split(".");
    let currentData: any = data;

    for (let i = 0; i < path.length; i++) {
      currentData = currentData[path[i]];

      if (!currentData) {
        throw new Error(
          `stringTemplate error: '${path[i]}' not found in ${tag}`
        );
      }

      if (i === path.length - 1) {
        return currentData;
      }
    }
  });
}
